/* global filter_obj, history */
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

jQuery(document).ready(function($) {
    initImgCarosuel();

    if ($('.ccs-dropdown').length > 0) {
        $('.ccs-dropdown .ccs-filter-title').click(function(e) {
            e.preventDefault();

            const currentDropdown = $(this).closest('.ccs-dropdown');
            const currentMenu = $(this).next('.ccs-filter-menu');

            // Close all other dropdowns
            $('.ccs-dropdown').not(currentDropdown).removeClass('is-active').find('.ccs-filter-menu').slideUp();

            // Toggle current dropdown
            currentDropdown.toggleClass('is-active');
            currentMenu.stop(true, true).slideToggle();
        });
    }

    if ($('.lg-filter-select').length > 0) {
        $('.lg-filter-select .lg-sort-by-label').click(function(e) {
            e.preventDefault();

            const currentDropdown = $(this).closest('.lg-filter-select');
            const currentMenu = $(this).next('.lg-filter-list');

            // Close all other dropdowns
            $('.lg-filter-select').not(currentDropdown).removeClass('is-active').find('.lg-filter-list').slideUp();

            // Toggle current dropdown
            currentDropdown.toggleClass('is-active');
            currentMenu.stop(true, true).slideToggle();
        });
    }

    // // Click outside → close all
    // $(document).click(function(e) {
    //     if (!$(e.target).closest('.ccs-dropdown').length && !$(e.target).closest('.lg-dropdown').length) {
    //         $('.ccs-dropdown').removeClass('is-active').find('.ccs-filter-menu').slideUp();
    //         $('.lg-dropdown').removeClass('active').find('.lg-filter-menu').slideUp();
    //     }
    // });

    /************* Post Filter - START *****************/
    function getSelectedSortValue() {
        return $('.post-ajax-filter form.listing-filter-form input[name="filter_order"]:checked').val() || '';
    }

    function updateSelectedSortLabel() {
        let $selectedSort = $('.post-ajax-filter form.listing-filter-form input[name="filter_order"]:checked');

        if (!$selectedSort.length) {
            $selectedSort = $('.post-ajax-filter form.listing-filter-form input[name="filter_order"][value=""]');
            $selectedSort.prop('checked', true);
        }

        const selectedSortLabel = $selectedSort.data('label') || $selectedSort.next('span').text();

        $('.post-ajax-filter form.listing-filter-form .lg-sort-selected').text(selectedSortLabel);
    }

    updateSelectedSortLabel();

    $('.post-ajax-filter form.listing-filter-form').on('submit', function(event) {
        event.preventDefault();
        
        const $form = $(this);
        const pager = $form.find('#pager').val();
        const posts_per_page = $form.find('input[name="posts_per_page"]').val();
        const search_text = $form.find('input[name="search_text"]').val();
        const sort_value = getSelectedSortValue();
        const post_type = $form.find('input[name="post_type"]').val() || 'product';

        // Collect all checked checkbox filters dynamically by name
        const filters = {};
        $form.find('input[type="checkbox"]:checked').each(function() {
            const name = $(this).attr('name');
            const val = $(this).val();
            if (name) {
                if (!filters[name]) {
                    filters[name] = [];
                }
                filters[name].push(val);
            }
        });

        // Convert array values to comma-separated strings
        for (const key in filters) {
            filters[key] = filters[key].join(',');
        }

        modify_post_filter_url(pager, search_text, sort_value, filters, post_type);
        post_filter_data(pager, posts_per_page, search_text, sort_value, filters, post_type);
    });

    // Filter form submission
    $(document).on('change keydown', '.post-ajax-filter form.listing-filter-form .search-text', function(e) {
        $('.post-ajax-filter form.listing-filter-form #pager').val(1);
    });

    $(document).on('change', '.post-ajax-filter form.listing-filter-form  .icon-search', function(e) {
        e.preventDefault();
        $('.post-ajax-filter form.listing-filter-form #pager').val(1);
        $('.post-ajax-filter form.listing-filter-form').submit();
    });

    // Category filter
    $('.post-ajax-filter form.listing-filter-form .cat-filter, .post-ajax-filter form.listing-filter-form input[name="filter_order"]').change(function() {
        updateSelectedSortLabel();
        $('.post-ajax-filter form.listing-filter-form #pager').val(1);
        $('.post-ajax-filter form.listing-filter-form').submit();
    });

    // Pagination next link
    $(document).on('click', '.post-ajax-filter form.listing-filter-form .pagination a.next', function(event) {
        event.preventDefault();
        const pager = $('.post-ajax-filter form.listing-filter-form input[name="pager"]').val();
        const max_pages = $('.post-ajax-filter form.listing-filter-form input[name="max_pages"]').val();
        if (+pager <= +max_pages) {
            $('.post-ajax-filter form.listing-filter-form #pager').val(+pager + 1);
            $('.post-ajax-filter form.listing-filter-form').submit();
        }
    });

    // Pagination prev link
    $(document).on('click', '.post-ajax-filter form.listing-filter-form .pagination a.prev', function(event) {
        event.preventDefault();
        const pager = $('.post-ajax-filter form.listing-filter-form input[name="pager"]').val();
        if (+pager >= 1) {
            $('.post-ajax-filter form.listing-filter-form #pager').val(+pager - 1);
            $('.post-ajax-filter form.listing-filter-form').submit();
        }
    });

    // Reset Filter
    $(document).on('click', '.post-ajax-filter form.listing-filter-form .filter-reset', function(e) {
        e.preventDefault();

        // Uncheck all checkboxes
        $('.post-ajax-filter form.listing-filter-form input[type="checkbox"]').prop('checked', false);

        // Clear text fields (like search)
        $('.post-ajax-filter form.listing-filter-form input[type="text"], .post-ajax-filter form.listing-filter-form input[type="search"]').val('');

        // Reset sort radio
        $('.post-ajax-filter form.listing-filter-form input[name="filter_order"][value=""]').prop('checked', true);
        updateSelectedSortLabel();

        // Reset selects
        $('.post-ajax-filter form.listing-filter-form select').prop('selectedIndex', 0);

        // Reset pagination
        $('.post-ajax-filter form.listing-filter-form #pager').val(1);

        // Submit the form to refresh results
        $('.post-ajax-filter form.listing-filter-form').submit();

        // Optional: Update the URL (clear all query params)
        const current_page_url = $('.post-ajax-filter form.listing-filter-form input[name="current_page_url"]').val();
        history.pushState(null, null, current_page_url);
    });

    /**
     * Post filter data function.
     *
     * @param {string} pager - The current page number.
     * @param {string} posts_per_page - The number of posts to display on each page.
     * @param {string} search_text - The search text entered by the user.
     * @param {string} sort_value - The selected sort order.
     * @param {object} filters - The selected taxonomy filters.
     * @param {string} post_type - The queried post type.
     */
    function post_filter_data(pager, posts_per_page, search_text, sort_value, filters, post_type) {
        const ajaxData = {
            action: 'fetch_post_list',
            pager: pager,
            posts_per_page: posts_per_page,
            search_text: search_text,
            sort_value: sort_value,
            post_type: post_type,
            ...filters,
        };

        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: filter_obj.ajax_url,
            data: ajaxData,
            beforeSend: function() {
                const $form = $('.post-ajax-filter form.listing-filter-form');
                const $lgGridArea = $form.find('.lg-grid-area');

                // Set current height inline
                $lgGridArea.css('height', $lgGridArea.outerHeight() + 'px');

                $form.find('.filter-load-more').show();
                $form.find('.pagination').hide();
                $form.find('.lg-grid-main-row').hide();
            },
            success: function(response) {
                const $form = $('.post-ajax-filter form.listing-filter-form');
                $form.find('.filter-load-more').hide();
                $form.find('.lg-grid-main-row').html(response.data).fadeIn();
                $form.find('.pagination').html(response.pagination).show();
                const $lgGridArea = $form.find('.lg-grid-area');

                // Set current height inline
                $lgGridArea.css('height', 'auto');
                if (response.total_pages) {
                    $form.find('input[name="max_pages"]').val(response.total_pages);
                }

                if (response.pager) {
                    $form.find('#pager').val(response.pager);
                }

                if (response.showing) {
                    $form.find('.showing-result').text(response.showing);
                }

                // Smooth scroll to top of results
                $('html, body').animate({
                    scrollTop: $('.post-ajax-filter').offset().top - 60,
                }, 800);
                initImgCarosuel();
            },
            error: function(xhr, status, error) {
                // Handle error if needed
            },
        });
    }

    /**
     * Modifies the current page URL with the provided filter parameters
     *
     * @param {string} pager - The current page number.
     * @param {string} search_text - The search text (if any).
     * @param {string} sort_value - The sort order value (if any).
     * @param {object} filters - The taxonomy filters.
     * @param {string} post_type - The post type.
     */
    function modify_post_filter_url(pager, search_text, sort_value, filters, post_type) {

        let query_string = '';
        const current_page_url = $('.post-ajax-filter form.listing-filter-form input[name="current_page_url"]').val();
        query_string += 'pager=' + pager;

        for (const key in filters) {
            if (filters[key] !== '' && typeof filters[key] !== 'undefined') {
                query_string += '&' + key + '=' + filters[key];
            }
        }

        if (search_text !== '' && typeof search_text !== 'undefined') {
            query_string += '&search_text=' + search_text;
        }

        if (sort_value !== '' && typeof sort_value !== 'undefined') {
            query_string += '&filter_order=' + sort_value;
        }

        // Determine if a separator is needed
        const separator = current_page_url.includes('?') ? '&' : '?';
        const updated_url = current_page_url + '' + separator + query_string;

        // Update the browser URL without refreshing the page
        history.pushState(null, null, updated_url);
    }
    /************* Post Filter - END *****************/
    
});

function initImgCarosuel() {
    const sliders = document.querySelectorAll('.lg-grid-img-slider:not(.swiper-initialized)');

    sliders.forEach((slider) => {
        new Swiper(slider, {
            slidesPerView: 1,
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            allowTouchMove: false,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            pagination: {
                el: slider.querySelector('.lg-pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: slider.querySelector('.lg-button-next'),
                prevEl: slider.querySelector('.lg-button-prev'),
            },
        });
    });
}
